import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import Config from 'react-native-config';
import { DFDHeaders } from 'serverTypes/authentication';

export const GET_TOOLTIPS = 'TOOLTIPS.GET_TOOLTIPS';
export const GET_TOOLTIPS_FAIL = 'TOOLTIPS.GET_TOOLTIPS_FAIL';
export const GET_TOOLTIPS_SUCCESS = 'TOOLTIPS.GET_TOOLTIPS_SUCCESS';

export const getTooltips = (page?: string) => ({
  type: GET_TOOLTIPS,
  payload: {
    client: 'dispatcher',
    request: {
      method: 'get',
      url: getDispatcherUrl(
        DispatcherCategoryService.APP_SETTINGS,
        DispatcherAuthPrefix.PUBLIC,
        DispatcherResource.APP_SETTINGS,
        DispatcherEndpoint.GLOSSARY
      ),
      params: {
        page
      },
      headers: {
        [DFDHeaders.mhpAdapter]: AdapterSource.MHP,
        settingskey: Config.APP_SETTINGS_KEY
      }
    }
  }
});
